<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${file.name}` }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="file" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "file-view-modal-logs",

  components: { LogListTable },

  props: ["file"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
